import React from 'react';
import styles from '../styles';
import useMediaQuery from '../hooks/useMediaQuery';
// Assuming these images will be added later or are available under a different name
import fallImage from '../assets/fall-detection.png';
import callImage from '../assets/phone-call.png';
import knockImage from '../assets/triple-knock.png';
import inactivityImage from '../assets/inactvity.png';
import medicalIdImage from '../assets/medical-id.png';
import { useLanguage } from '../contexts/LanguageContext';

const DetailedFeatures = () => {
    const isMobile = useMediaQuery('(max-width: 768px)');
    const { t } = useLanguage();

    const featuresStyles = {
        container: {
            ...styles.section,
            backgroundColor: '#FAFAFA',
            padding: isMobile ? '3rem 1rem' : '4rem 2rem',
        },
        featureRow: {
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'center',
            justifyContent: 'center', // Center content horizontally
            marginBottom: isMobile ? '4rem' : '6rem',
            gap: isMobile ? '2rem' : '4rem',
            maxWidth: '1200px',
            margin: '0 auto', // Center the row
        },
        imageContainer: {
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%', // Ensure container takes full width on mobile
        },
        image: {
            maxWidth: '100%', // Make image responsive
            maxHeight: '500px', // Limit height
            height: 'auto',
            objectFit: 'contain',
        },
        textContainer: {
            flex: 1,
            padding: isMobile ? '0' : '0 2rem',
            textAlign: isMobile ? 'center' : 'left',
        },
        title: {
            ...styles.h2,
            marginBottom: '1rem',
        },
        description: {
            ...styles.bodyText,
            marginBottom: '1.5rem',
            lineHeight: '1.8',
        },
        footnote: {
            fontSize: '0.75rem',
            color: '#718096',
            lineHeight: '1.5',
            maxWidth: '700px',
            marginTop: '-0.75rem',
            marginBottom: '1.5rem',
        },
    };

    const features = [
        {
            title: t('detailedFeatures.callTitle'),
            description: t('detailedFeatures.callDescription'),
            image: callImage, // Placeholder
            imageAlt: "Direct SOS Call Screen",
            reverse: false,
        },
        {
            title: t('detailedFeatures.knockTitle'),
            description: t('detailedFeatures.knockDescription'),
            image: knockImage, // Placeholder
            imageAlt: "Triple Knock Alert Screen",
            reverse: true,
        },
        {
            title: t('detailedFeatures.fallTitle'),
            description: t('detailedFeatures.fallDescription'),
            footnote: t('detailedFeatures.fallFootnote'),
            image: fallImage, // Placeholder
            imageAlt: "Fall Detection Settings",
            reverse: false,
        },
        {
            title: t('detailedFeatures.inactivityTitle'),
            description: t('detailedFeatures.inactivityDescription'),
            image: inactivityImage, // Placeholder
            imageAlt: "Inactivity Alert Countdown",
            reverse: true,
        },
        {
            title: t('detailedFeatures.medicalIdTitle'),
            description: t('detailedFeatures.medicalIdDescription'),
            image: medicalIdImage,
            imageAlt: "Medical ID Screen",
            reverse: false,
        },
    ];

    return (
        <section style={featuresStyles.container}>
            {features.map((feature, index) => (
                <div
                    key={index}
                    style={{
                        ...featuresStyles.featureRow,
                        flexDirection: isMobile ? 'column' : (feature.reverse ? 'row-reverse' : 'row'),
                        marginBottom: index === features.length - 1 ? 0 : featuresStyles.featureRow.marginBottom, // Remove margin for last item
                    }}
                >
                    <div style={featuresStyles.imageContainer}>
                        {feature.image ? (
                            <img src={feature.image} alt={feature.imageAlt} style={featuresStyles.image} />
                        ) : (
                            <div style={{
                                width: '260px',
                                height: '480px',
                                backgroundColor: '#F0F0F0',
                                borderRadius: '24px',
                                border: '2px dashed #CCCCCC',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#AAAAAA',
                                fontSize: '0.9rem',
                                fontStyle: 'italic',
                            }}>
                                Screenshot coming soon
                            </div>
                        )}
                    </div>
                    <div style={featuresStyles.textContainer}>
                        <h3 style={featuresStyles.title}>{feature.title}</h3>
                        <p style={featuresStyles.description}>{feature.description}</p>
                        {feature.footnote && (
                            <p style={featuresStyles.footnote}>{feature.footnote}</p>
                        )}
                    </div>
                </div>
            ))}
        </section>
    );
};

export default DetailedFeatures;
